export default "__VITE_ASSET__BcOanJH$__"